<ng-container *ngIf="antwoordResultaat">  
  <div data-hj-suppress class="ols-summary-answer">{{transformToDate(getAnswer())}}</div>
</ng-container>